import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useCms } from '../context/CmsContext'

export function CookieConsent() {
  const { data } = useCms()
  const [choice, setChoice] = useState(() => localStorage.getItem('wm-cookie-consent'))
  if (data.settings['cookie.enabled'] !== 'true' || choice) return null
  const choose = (value:'accepted'|'essential') => { localStorage.setItem('wm-cookie-consent', value); setChoice(value); if(value==='accepted') window.location.reload() }
  return <div className="cookie-banner" role="dialog" aria-label="Cookie preferences">
    <div><strong>Your privacy, your choice.</strong><p>We use essential storage for website functions. Analytics and marketing tools load only with your permission. Read our <Link to="/cookie-policy">Cookie Policy</Link>.</p></div>
    <div className="cookie-actions"><button className="button ghost" onClick={()=>choose('essential')}>Essential only</button><button className="button" onClick={()=>choose('accepted')}>Accept analytics</button></div>
  </div>
}
